import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { header_es_AR } from 'assets/i18n/header-es-ar';
import { privacyPolicyModel } from './privacy-policy-model';
import { SeoService } from '@app/core/services/seo.service';
import { OgService } from '@app/core/services/og.service';

@Component({
    selector: 'app-private-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent {
    public privacyPolicies: Array<{ [key: string]: string }> = privacyPolicyModel;

    public constructor(private seoService: SeoService, private ogService: OgService, private translateService: TranslateService) {
        let langs: any = {
            ...header_es_AR
        };
        this.translateService.setTranslation('privacy-policy', langs, true);
        this.translateService.use('privacy-policy');

        this.seoService.addTitle('Políticas de privacidad | Saldoar');
        this.ogService.addOpenGraphMetadata({ url: 'wiki/privacy-policy' });
        this.seoService.addCanonical('wiki/privacy-policy');
    }
}
